/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sklik_Retargeting_ListInputs */

const cs_sklik_retargeting_list = /** @type {(inputs: Sklik_Retargeting_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID retargetingového e-mailového seznamu`)
};

const en_sklik_retargeting_list = /** @type {(inputs: Sklik_Retargeting_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retargeting email list ID`)
};

/**
* | output |
* | --- |
* | "Retargeting email list ID" |
*
* @param {Sklik_Retargeting_ListInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sklik_retargeting_list = /** @type {((inputs?: Sklik_Retargeting_ListInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sklik_Retargeting_ListInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sklik_retargeting_list(inputs)
	return cs_sklik_retargeting_list(inputs)
});